import {
  Box,
  IconButton,
  Stack,
  Tooltip
} from '@mui/material';
import { GridToolbarFilterButton } from '@mui/x-data-grid';
import { Delete } from 'mdi-material-ui';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';


const LeadToolbar = props => {
  const { numSelected, selected, setReload } = props

  const DeleteLead = async () => {
    selected.forEach(async item => {
      try {
        await apiService.delete(`/lead/${item.mb_id}`);
        toast.success('항목이 삭제되었습니다.');
        setReload(reload => reload + 1);
      } catch (error) {
        console.error(error);
      }
    });
  }

  return (
    <Box
      sx={{
        p: 2,
        pb: 0,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }}
    >
      <Box>
        <GridToolbarFilterButton />
      </Box>
      <Box sx={{ display: 'flex' }}>
        {numSelected > 0 ? (
          <Stack direction="row" spacing={2} sx={{ pr: 4 }}>
            <Tooltip title='Delete'>
              <IconButton sx={{ color: '#f44336' }} onClick={DeleteLead} >
                <Delete />
              </IconButton>
            </Tooltip>
          </Stack>
        ) : null}        
      </Box>
    </Box>
  )
}

export default LeadToolbar
